module.exports = __webpack_public_path__ + "img/icon-reddit-dark.75bf471c.svg";